import React from "react";
import Button from "../../UI/Button";
const GalleryActions = ({ selected, onUpload, makeProfile, onDelete }) => {
  if (selected === 0) {
    return (
      <div className="row" style={{ marginBottom: "1em" }}>
        <div className="col-sm-4 col-sm-offset-4 text-center">
          <Button
            label="Upload Images"
            info
            medium
            clean
            rounded
            onClick={onUpload}
          />
        </div>
      </div>
    );
  } else if (selected === 1) {
    return (
      <div className="row" style={{ marginBottom: "1em" }}>
        <div className="col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 text-center">
          <Button
            label="Make Profile Picture"
            info
            medium
            clean
            rounded
            onClick={makeProfile}
          />
          <Button
            label="Delete Image"
            info
            medium
            clean
            rounded
            onClick={onDelete}
            style={{ marginLeft: "15px" }}
          />
        </div>
      </div>
    );
  } else {
    return (
      <div className="row" style={{ marginBottom: "1em" }}>
        <div className="col-sm-4 col-sm-offset-4 text-center">
          <Button
            label="Delete Selected Images"
            info
            medium
            clean
            rounded
            onClick={onDelete}
          />
        </div>
      </div>
    );
  }
};

export default GalleryActions;



// WEBPACK FOOTER //
// ./src/_components/Gallery/GalleryActions/index.js